import React from "react";

interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  sublabel?: string;
  suffix?: string;
  altSuffix?: string;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  value,
  onChange,
  min = 1,
  max = 20,
  label,
  sublabel,
  suffix = "",
  altSuffix = "",
}) => {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className="flex gap-5 justify-center items-center p-5 mb-3 border-t border-b border-solid border-y-neutral-200">
      <button
        className="w-10 h-10 text-lg border border-solid transition-all cursor-pointer border-neutral-200 duration-[0.3s] ease-[ease]"
        onClick={handleDecrease}
      >
        -
      </button>
      <div className="text-sm font-light text-center uppercase min-w-[120px]">
        {sublabel && (
          <div className="mb-1.5 text-xs text-stone-500">{sublabel}</div>
        )}
        <span>{value}</span>
        {value === 1 ? (
          <span>{suffix}</span>
        ) : (
          <span>{altSuffix || suffix}</span>
        )}
      </div>
      <button
        className="w-10 h-10 text-lg border border-solid transition-all cursor-pointer border-neutral-200 duration-[0.3s] ease-[ease]"
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
};
